import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Jumbotron, Form, Col, Table, Button, Alert, Row } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../../menu';
import config from '../../../config';
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
import Numeroaletras from '../../../middleware/numbertoletter';
import funciones from '../../../middleware/funciones';
import SearchItem from '../../subcomponent/searchItem';
import SearchClient from '../../subcomponent/searchClient';
import ModalConfirm from '../../subcomponent/modalConfirm';

class Facturas extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            showAlert: false,
            numeroDocumento: 0,
            clientes: [],
            prefijos: [],
            forma_pago: [],
            vendedores: [],
            retenciones: [],
            bodegas: [],
            inventario: [],
            infovendedor: [],
            bodega: "",
            currentUser,
            PREFIJO: "",
            FORMA_PAGO: "",
            NUMERO_FACTURA: 0,
            CLIENTE: "",
            cod_lista: "",
            tope: 100,
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            SHOW_DETAIL: false,
            data_items: [],
            items_barcode: [],
            detalle_factura: [],
            data_cliente: [],
            isInv: 1,
            infoEmpresa: {
                ROUND_TOTAL : 0
            },
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            }
        };
    }
    componentDidMount() {
        this.initFactura();
    }

    initFactura = () => {
        const inputName = document.getElementById("Nombre");
        if (inputName) inputName.value = "";
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': 'FV',
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/invoice/', datasend).then(response => response.json())
            .then(data => {
                const cData = data.data;
                const clientes = cData[0];
                const prefijos = cData[1];
                const forma_pago = cData[2];
                const vendedores = cData[3];
                const retenciones = cData[4];
                const bodegas = cData[6];
                const inventario = cData[7];
                const infovendedor = cData[8];
                const infoEmpresa =( cData[9]) ? cData[9][0] : this.state.infoEmpresa;
                let tope = 100;
                if (infovendedor.length > 0) {
                    tope = infovendedor[0]["TOPE_DSCTO"];
                }
                this.setState({
                    clientes,
                    prefijos,
                    forma_pago,
                    vendedores,
                    retenciones,
                    bodegas,
                    inventario,
                    tope,
                    PREFIJO: "",
                    FORMA_PAGO: "",
                    NUMERO_FACTURA: 0,
                    CLIENTE: "",
                    SHOW_DETAIL: false,
                    infoEmpresa
                });
                this.clearItem();
            });
    }
    changePrefijo = ({ target }) => {
        const numero = target.selectedOptions[0].title;
        let showDetail = false;
        if (numero && this.state.CLIENTE !== "") {
            showDetail = true
        }
        this.setState({
            PREFIJO: target.value,
            NUMERO_FACTURA: numero,
            SHOW_DETAIL: showDetail,
            showAlert: false
        });

    }

    changeCantidad = ({ target }, position) => {
        const newDetalle = this.state.detalle_factura;
        let { value } = target;
        const { name } = target;
        if (name === "DESCUENTO" && value > 100) value = 100;
        newDetalle.forEach((element, index) => {
            if (position === index) {
                if (name === "CANTIDAD") element.CANTIDAD = value;
                if (name === "DESCUENTO") element.DESCUENTO = value;
                if (name === "VALOR_UNI") element.VALOR_UNI = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });
        this.calcTotales();
    }

    specialValidation=()=>{
        const {empresa} = this.state;
        const cliente = this.state.data_cliente[0];

        if(empresa==='890304967' || empresa === '800149912'){
            if(cliente.DOCUMENTO_CLIENTE=== '899999239') return true;       
        }

        return false;    
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_factura;
        const { retenciones } = this.state;
        const { data_cliente } = this.state;
        const isRounded = this.specialValidation();
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            element.TOTAL = (element.CANTIDAD * element.VALOR_UNI);
            element.VALOR_DCTO = funciones.round((element.TOTAL * element.DESCUENTO / 100), 2);
            element.VALOR_IVA = ((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100);
            if(isRounded) element.VALOR_IVA = Math.round(element.VALOR_IVA);
            element.RENTA_DETALLE = ((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_RETENCION / 100);

            RENTA += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
            RETENCION += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
            TOTAL_BRUTO += element.TOTAL;
            TOTAL_IVA += element.VALOR_IVA;
            TOTAL_DESCUENTOS += element.VALOR_DCTO;
            SUBTOTAL = TOTAL_BRUTO - TOTAL_DESCUENTOS;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA;
        });
        newDetalle.forEach(element => {
            if (element.BASE_MINIMA_VENTA > SUBTOTAL) {
                RENTA -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                RETENCION -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                element.RENTA_DETALLE = 0;
            }
        });
        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (TOTAL_IVA * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;

        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_factura: newDetalle,
            totales: newTotal
        })
    }

    removeitem = (index) => {
        let newData = this.state.detalle_factura;

        newData.splice(index, 1);

        ////console.log(newData);
        this.setState({ detalle_factura: newData });
        this.calcTotales();
    }

    clearItem = () => {
        this.setState({
            detalle_factura: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        let item_detalle = [];

        const cliente = this.state.data_cliente[0];
        const { totales } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        //const { retenciones } = this.state;
        const { detalle_factura } = this.state;
        const valorTexto = Numeroaletras(totales.TOTAL_PAGAR);
        let currentForma = []
        forma_pago.forEach(element => {
            if (element.ID_FORMAS_PAGO.toString() === this.state.FORMA_PAGO.toString()) {
                currentForma = element;
            }
        });

        let vencimiento = new Date(today);
        vencimiento.setDate(vencimiento.getDate() + currentForma.PERIODICIDAD)
        const vendd = String(vencimiento.getDate()).padStart(2, '0');
        const venmm = String(vencimiento.getMonth() + 1).padStart(2, '0'); //January is 0!venmm
        const venyyyy = vencimiento.getFullYear();
        const vencimientoFormat = venyyyy + "-" + venmm + "-" + vendd;

        let currentVend = []
        vendedores.forEach(element => {
            if (element.ID_USUARIO.toString() === this.state.VENDEDOR_SELECTED.toString()) {
                currentVend = element;
            }
        });
        const subtotal_send = totales.SUBTOTAL + totales.TOTAL_DESCUENTOS + totales.TOTAL_IVA;
        const Cabecera = {
            ID_EMPRESA: this.state.empresa,
            CODIGO_EMPRESA: '01',
            CENTRO_OPERACION: '01',
            NUMERO_FACTURA_CABECERA: this.state.NUMERO_FACTURA,
            TIPO_DOCUMENTO_CABECERA: this.state.PREFIJO,
            NUMERO_REMISION: "",
            NUMERO_PEDIDO: "",
            DOCUMENTO_ALTERNO: "",
            ID_TRANSACCION: "",
            DOCUMENTO_CLIENTE: cliente.DOCUMENTO_CLIENTE,
            DIGITO_VERIFICACION_CLIENTE: cliente.DV_CLIENTE,
            TIPO_IDENTIFICACION_CLIENTE: cliente.TIPO_IDENTIFICACION,
            NOMBRE_CLIENTE: cliente.NOMBRE_CLIENTE,
            DIRECCION_CLIENTE: cliente.DIRECCION_CLIENTE,
            DEPARTAMENTO_CLIENTE: cliente.NOMBRE_DEPARTAMENTO_CLIENTE,
            CODIGO_POSTAL: cliente.CODIGO_POSTAL,
            CIUDAD_CLIENTE: cliente.NOMBRE_CIUDAD_CLIENTE,
            CODIGO_DEPARTAMENTO_CLIENTE: cliente.CODIGO_DEPARTAMENTO_CLIENTE,
            CODIGO_CIUDAD_CLIENTE: cliente.CODIGO_CIUDAD_CLIENTE,
            TELEFONO_CLIENTE: cliente.TELEFONO_FIJO_CLIENTE,
            EMAIL_CLIENTE: cliente.EMAIL_CLIENTE,
            VENDEDOR: currentVend.NOMBRE_COMPLETO,
            FECHA_DOCUMENTO: todayFormat,
            FECHA_VENCIMIENTO_DOCUMENTO: vencimientoFormat,
            FECHA_DOCUMENTO_ALTERNO: "",
            PORCENTAJE_IVA: 0,
            PORCENTAJE_IMPOCONSUMO: 0,
            TOTAL_BRUTO: totales.TOTAL_BRUTO,
            TOTAL_DESCUENTO_LINEA: totales.TOTAL_DESCUENTOS,
            TOTAL_DESCUENTO_GLOBAL: 0,
            TOTAL_IVA: totales.TOTAL_IVA,
            TOTAL_IMPOCONSUMO: 0,
            TOTAL_RETENCION: totales.RETENCION,
            RET_IVA: this.state.RETEIVA,
            RET_ICA: this.state.RETEICA,
            RET_FUENTE: this.state.RENTA,
            RET_OTROS: this.state.RETEOTROS,
            SUBTOTAL: subtotal_send,
            TOTAL_VENTA: totales.TOTAL_PAGAR,
            CONDICION_PAGO: currentForma.DESCRIPCION_FORMA_PAGO,
            VALOR_LETRAS: valorTexto,
            TASA_MONEDA: "1",
            TIPO_MONEDA: "COP",
            OBSERVACION1: this.state.OBSERVACION_FACTURA,
            OBSERVACION2: "",
            CUFE: "",
            DOCUMENTO_ENVIADO: 0,
            DOCUMENTO_ENVIADO_OBSERVACION: "",
            PDF: "",
            PREFIJO_DIAN: this.state.PREFIJO,
            FACTURA_ASOCIADA: "",
            BARRIO: cliente.BARRIO_CLIENTE,
            CODIGO_VENDEDOR: currentVend.CODIGO_VENDEDORES
        }

        let Detalle = []

        detalle_factura.forEach((element, index) => {
            if (element.DESCRIPCION_ITEM !== "") {
                const datosUnidad = element.UNIDAD_MEDIDA.split(";;");

                Detalle.push(
                    {
                        ID_EMPRESA: this.state.empresa,
                        CODIGO_EMPRESA: '01',
                        CENTRO_OPERACION: '01',
                        NUMERO_FACTURA_DETALLE: this.state.NUMERO_FACTURA,
                        TIPO_DOCUMENTO_DETALLE: this.state.PREFIJO,
                        INDICE_ITEM: index + 1,
                        ITEM_ID: element.ID_ITEMS,
                        ITEM_DESCRIPCION: element.DESCRIPCION_ITEM,
                        SERIAL: "",
                        UNIDAD_MEDIDA: datosUnidad[1],
                        CANTIDAD_1: element.CANTIDAD,
                        CANTIDAD_2: element.CANTIDAD, //parseFloat(datosUnidad[3]) * parseFloat(element.CANTIDAD),
                        PRECIO_UNITARIO_DETALLE: element.VALOR_UNI,
                        TOTAL_BRUTO_DETALLE: element.TOTAL,
                        DESCUENTO_LINEA_DETALLE: element.VALOR_DCTO,
                        IVA_DETALLE: element.VALOR_IVA,
                        IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_IVA_DETALLE: element.PORCENTAJE_IVA,
                        PORCENTAJE_IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_DESCUENTO_DETALLE: element.DESCUENTO,
                        ID_UNIDAD_MEDIDA: datosUnidad[0]
                    }
                );
                item_detalle.push({
                    motivo: "S",
                    ID_ITEMS: element.ID_ITEMS,
                    cantidad: element.CANTIDAD,
                    costo: 0,
                    observacion: ""
                });
            }
        });

        const factura = {
            Tipo: "F",
            Cabecera,
            Detalle
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(factura),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        };

        fetch(config.servBackEnd + '/invoice/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datasend = {
                        method: 'POST',
                        body: JSON.stringify({
                            empresa: this.state.empresa,
                            bodega: this.state.bodega,
                            tipoMov: this.state.PREFIJO,
                            observacion: this.state.OBSERVACION_FACTURA,
                            numeroDoc: data.DOCUMENTO_CREADO,
                            items: item_detalle
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'tipo': this.state.tipo,
                        }
                    }
                    if (this.state.isInv === 1) {
                        fetch(config.servBackEnd + '/inventary/create', datasend).then(response => response.json())
                            .then(data => { console.log(data) });
                    }
                    this.setState({ showAlert: true, numeroDocumento: data.DOCUMENTO_CREADO });
                    this.initFactura();
                } 
            });


    }

    addItem = (data) => {
        ////console.log(listUnidad);
        const LISTA_UNI = (data.LISTA_UNIDADES || [])
        let UNIDAD_MEDIDA = "";
        LISTA_UNI.forEach(element => {
            if (element.FACTOR === 1) {
                UNIDAD_MEDIDA = element.ID_UNIDAD + ";;" + element.DESCRIPCION_FACTOR + ";;" + element.PRECIO + ";;" + element.FACTOR;
            }
        });
        const infoCliente = this.state.data_cliente[0];
        const newdetalle = this.state.detalle_factura;
        const { bodega } = this.state;
        const iva = (infoCliente.LIQUIDA_IVA) ? data.IVA_ITEM : 0;
        const precio = funciones.round((infoCliente.INC_IVA) ? (data.PRECIO / (1 + (iva / 100))) : data.PRECIO, 2);
        newdetalle.push({
            ID_ITEMS: data.ID_ITEMS,
            DESCRIPCION_ITEM: data.DESCRIPCION_ITEM,
            CANTIDAD: 1,
            CANTIDAD_2: 1,
            DESCUENTO: 0,
            UNIDAD_MEDIDA,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            PORCENTAJE_IVA: iva,
            TOTAL: precio,
            PORCENTAJE_RETENCION: (infoCliente.LIQUIDA_RENTA) ? data.PORCENTAJE_RETENCION : 0,
            BASE_MINIMA_VENTA: data.BASE_MINIMA_VENTA,
            disponible: 0,
            LISTA_UNIDADES: LISTA_UNI
        });
        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
        this.updateCantidadDisponible(bodega);
    }

    selectCLient = (client) => {
        const value = client.ID_CLIENTES;
        let showDetail = false;
        if (value) {
            if (this.state.PREFIJO !== "") showDetail = true;
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/invoice/detail/' + value, datasend).then(response => response.json())
                .then(data => {
                    const cData = data.data;
                    const cCliente = cData[0];
                    const cItems = cData[1];
                    const items_barcode = cData[2];
                    const vend = cCliente[0]["VENDEDOR_ASOCIADO"];
                    const list = cCliente[0]["LISTA_CLIENTE"];
                    this.setState({
                        CLIENTE: value,
                        cod_lista: list,
                        SHOW_DETAIL: showDetail,
                        data_items: cItems,
                        data_cliente: cCliente,
                        VENDEDOR_SELECTED: vend,
                        totales: {
                            TOTAL_BRUTO: 0,
                            RETENCION: 0,
                            TOTAL_IVA: 0,
                            SUBTOTAL: 0,
                            TOTAL_DESCUENTOS: 0,
                            TOTAL_PAGAR: 0
                        },
                        RENTA: 0,
                        RETEIVA: 0,
                        RETEICA: 0,
                        RETEOTROS: 0,
                        detalle_factura: [],
                        items_barcode
                    });
                });
        } else {
            //console.log("Seleccione un cliente");
        };
    }

    changeBodegaOrigen = ({ target }) => {
        const { bodegas } = this.state;
        let isInv = false;
        bodegas.forEach(element => {
            if (element.ID_BODEGAS.toString() === target.value) isInv = element.AFECTA_INVENTARIO;
        });
        this.setState({ bodega: target.value, isInv });
        this.updateCantidadDisponible(target.value);
    }

    updateCantidadDisponible = (bod) => {
        const new_list_items = this.state.detalle_factura;
        const bodega_origen = bod;

        new_list_items.forEach(element => {
            element.disponible = this.findQuantity(element.ID_ITEMS, bodega_origen);
        });

        this.setState({
            detalle_factura: new_list_items
        });
    }

    findQuantity = (item, bodega) => {
        const { inventario } = this.state;
        for (let index = 0; index < inventario.length; index++) {
            const element = inventario[index];
            if (element.ID_BODEGA.toString() === bodega.toString() && element.ID_ITEMS.toString() === item.toString()) {
                return (element.CANTIDAD);
            }
        }
        return 0;
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    changeUnit = ({ target }, index) => {
        const newDetalle = this.state.detalle_factura;
        newDetalle.forEach((element, i) => {
            if (index === i) {
                const datos = target.value.split(";;");
                element.UNIDAD_MEDIDA = target.value;
                element.VALOR_UNI = datos[2];
            }
        });
        this.setState({ detalle_factura: newDetalle })
        this.calcTotales();
    }

    addItemBarCode = (data) => {
        ////console.log(listUnidad);
        const LISTA_UNI = (data.LISTA_UNIDADES || [])
        let UNIDAD_MEDIDA = "";
        LISTA_UNI.forEach(element => {
            if (element.FACTOR === 1) {
                UNIDAD_MEDIDA = element.ID_UNIDAD + ";;" + element.DESCRIPCION_FACTOR + ";;" + element.PRECIO + ";;" + element.FACTOR;
            }
        });
        const infoCliente = this.state.data_cliente[0];
        const newdetalle = this.state.detalle_factura;
        const { bodega } = this.state;
        const iva = (infoCliente.LIQUIDA_IVA) ? data.IVA_ITEM : 0;
        const precio = funciones.round((infoCliente.INC_IVA) ? (data.PRECIO / (1 + (iva / 100))) : data.PRECIO, 2);
        newdetalle.push({
            ID_ITEMS: data.ID_ITEMS,
            DESCRIPCION_ITEM: data.DESCRIPCION_ITEM,
            CANTIDAD: data.CANTIDAD_BARCODE,
            CANTIDAD_2: data.CANTIDAD_BARCODE,
            DESCUENTO: 0,
            UNIDAD_MEDIDA,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            PORCENTAJE_IVA: iva,
            TOTAL: precio,
            PORCENTAJE_RETENCION: (infoCliente.LIQUIDA_RENTA) ? data.PORCENTAJE_RETENCION : 0,
            BASE_MINIMA_VENTA: data.BASE_MINIMA_VENTA,
            disponible: 0,
            LISTA_UNIDADES: LISTA_UNI
        });
        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
        this.updateCantidadDisponible(bodega);
    }

    render() {
        const mensajeConfirm = "¿Está seguro que desea crear la factura?";
        const { prefijos } = this.state;
        const { clientes } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        const { cod_lista } = this.state;
        const { data_items } = this.state;
        const { totales } = this.state;
        const { currentUser } = this.state;
        const { numeroDocumento } = this.state;
        const { showAlert } = this.state;
        const { bodegas } = this.state;
        const { tope } = this.state;
        const { items_barcode } = this.state;
        const showInv = (this.state.isInv === 1) ? true : false;
        const changeCantidad = this.changeCantidad;
        const removeitem = this.removeitem;
        const clearItem = this.clearItem;
        const saveInvoice = this.saveInvoice;
        //const changeUnit = this.changeUnit;
        return (
            <div className="contenedor">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h1>Modulo Facturas</h1>
                </Jumbotron>
                {showAlert &&
                    <Alert variant='success'>
                        El documento No {numeroDocumento}  se creo satisfactoriamente.
                </Alert>
                }
                <Form onSubmit={saveInvoice}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="">
                            <Form.Label>TIPO DOCUMENTO</Form.Label>
                            <Form.Control as="select" onChange={this.changePrefijo} value={this.state.PREFIJO} required>
                                <option value="">Seleccione</option>
                                {prefijos.map(function (currentData, index) {
                                    return <option key={'p' + index} title={currentData.ULTIMO_DIGITO + 1} value={currentData.PREFIJO}>{currentData.PREFIJO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>CLIENTE</Form.Label>
                            <SearchClient data={clientes} event={this.selectCLient} ></SearchClient>
                        </Form.Group>
                        <Form.Group as={Col} controlId="">
                            <Form.Label>FORMA DE PAGO</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ FORMA_PAGO: e.target.value })} value={this.state.FORMA_PAGO} required >
                                <option value="">Seleccione</option>
                                {forma_pago.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_FORMAS_PAGO}>{currentData.DESCRIPCION_FORMA_PAGO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} controlId="">
                            <Form.Label>Bodega</Form.Label>
                            <Form.Control as="select" onChange={this.changeBodegaOrigen} value={this.state.bodega} required >
                                <option value="">Seleccione</option>
                                {
                                    bodegas.map((bodega, i) => {
                                        return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                    })
                                }
                            </Form.Control>
                        </Form.Group>

                        {currentUser === "0" && <Form.Group as={Col} controlId="">
                            <Form.Label>VENDEDOR</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ VENDEDOR_SELECTED: e.target.value })} value={this.state.VENDEDOR_SELECTED} required >
                                <option value="">Seleccione</option>
                                {vendedores.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_USUARIO}>{currentData.NOMBRE_COMPLETO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>}
                    </Form.Row>
                    <Form.Row>
                        <Form.Label>OBSERVACIONES</Form.Label>
                        <Form.Control type="text" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />
                    </Form.Row>
                    {this.state.SHOW_DETAIL &&
                        <div>
                            <Button className="m-2" type="submit" disabled={detalle_factura.length === 0}>Finalizar Documento</Button>
                            <Button className="m-2" onClick={clearItem} disabled={detalle_factura.length === 0} >Limpiar</Button>
                        </div>
                    }
                    {this.state.SHOW_DETAIL &&
                        <div>
                            <Row>
                                <Col sm={3}>
                                    <SearchItem idLista={cod_lista} data={data_items} event={this.addItem} data_barcode={items_barcode} event_barcode={this.addItemBarCode} ></SearchItem>
                                </Col>
                                <Col>
                                    <Table striped bordered hover size="sm" responsive>
                                        <thead>
                                            <tr>
                                                {/* <th>CODIGO</th> */}
                                                <th></th>
                                                <th colSpan={(showInv === true) ? 2 : 3}>DESCRIPCION</th>
                                                {showInv && <th>DISP.</th>}
                                                {/* <th>UND.</th> */}
                                                <th>CANT.</th>
                                                <th>% DSCTO</th>
                                                <th>VR UNIT.</th>
                                                <th>VR DSCTO</th>
                                                <th>VR IVA</th>
                                                <th>TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detalle_factura.map(function (element, index) {
                                                return <tr key={'tr' + index}>
                                                    <td>
                                                        <IconContext.Provider value={{ size: "2em" }}>
                                                            <IoIosRemoveCircle onClick={() => removeitem(index)} />
                                                        </IconContext.Provider>
                                                    </td>
                                                    <td colSpan={(showInv === true) ? 2 : 3}>{element.DESCRIPCION_ITEM}</td>
                                                    {(showInv) && <td> {element.disponible}</td>}
                                                    {/* <td>
                                                        <Form.Control as="select" onChange={(e => changeUnit(e, index))} value={element.UNIDAD_MEDIDA} required>
                                                            {element.LISTA_UNIDADES.map(function (currentUnit,  j) {
                                                                return <option key={'un'+ j} value={currentUnit.ID_UNIDAD+";;"+currentUnit.DESCRIPCION_FACTOR+";;"+currentUnit.PRECIO+";;"+currentUnit.FACTOR} >{currentUnit.DESCRIPCION_FACTOR}</option>;
                                                            })}
                                                        </Form.Control>
                                                    </td> */}
                                                    <td> <Form.Control className="shortinput" step="0.01" name="CANTIDAD" min="0.01" max={(showInv) ? element.disponible : 99999999999} type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.CANTIDAD} /></td>
                                                    <td> <Form.Control className="shortinput"  name="DESCUENTO" min="0" step="0.01" max={tope} type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.DESCUENTO} /></td>
                                                    <td> <Form.Control className="mediuminput" name="VALOR_UNI" min="0" type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === "" || cod_lista !== 0} value={element.VALOR_UNI} /></td>
                                                    <td>{funciones.round(element.VALOR_DCTO, 2)}</td>
                                                    <td>{funciones.round(element.VALOR_IVA, 2)}</td>
                                                    <td>{funciones.round(element.TOTAL, 2)}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </Table>
                                    <Table striped bordered hover size="sm" responsive>
                                        <tbody>
                                            <tr>
                                                <td><b>TOTAL BRUTO</b></td>
                                                <td>{funciones.round(totales.TOTAL_BRUTO, 2)}</td>
                                                <td><b>TOTAL DESCUENTOS</b></td>
                                                <td>{funciones.round(totales.TOTAL_DESCUENTOS, 2)}</td>
                                                <td><b>SUBTOTAL</b></td>
                                                <td>{funciones.round(totales.SUBTOTAL, 2)}</td>
                                                <td><b>RETENCION</b></td>
                                                <td>{funciones.round(totales.RETENCION, 2)}</td>
                                                <td><b>TOTAL IVA</b></td>
                                                <td>{funciones.round(totales.TOTAL_IVA, 2)}</td>
                                            </tr>
                                            <tr>
                                                <td><b>RENTA</b></td>
                                                <td>{funciones.round(this.state.RENTA, 2)}</td>
                                                <td><b>RETEIVA</b></td>
                                                <td>{funciones.round(this.state.RETEIVA, 2)}</td>
                                                <td><b>RETEICA</b></td>
                                                <td>{funciones.round(this.state.RETEICA, 2)}</td>
                                                <td><b>RETEOTROS</b></td>
                                                <td>{funciones.round(this.state.RETEOTROS, 2)}</td>
                                                <td><b>TOTAL</b></td>
                                                <td>{funciones.round(totales.TOTAL_PAGAR, 0)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    }
                </Form>
            </div>
        );
    }
}
export default (Facturas);